import React from 'react';
import type { NewSizingSnapshot } from '@/sizing/newSizingEngine';
import { SizingHeroCard } from './SizingHeroCard';
import { BottleneckSummaryCard } from './BottleneckSummaryCard';
import { PercentileCapacityChart } from './PercentileCapacityChart';

interface SizingSummaryDashboardProps {
  snapshot: NewSizingSnapshot | null;
  serverCount: number;
  gpusPerServer: number;
  serverDisplayName?: string;
  acceleratorDisplayName?: string;
}

export const SizingSummaryDashboard = ({
  snapshot,
  serverCount,
  gpusPerServer,
  serverDisplayName,
  acceleratorDisplayName,
}: SizingSummaryDashboardProps) => {

  return (
    <div className="space-y-6">
      {/* Hero Card - Full Width */}
      <SizingHeroCard
        snapshot={snapshot}
        serverCount={serverCount}
        gpuCount={snapshot?.finalGpuCount ?? 0}
        serverDisplayName={serverDisplayName}
        acceleratorDisplayName={acceleratorDisplayName}
      />

      {/* Primary 2-Chart Grid */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <PercentileCapacityChart
          snapshot={snapshot}
          gpusPerServer={gpusPerServer}
        />
        <BottleneckSummaryCard snapshot={snapshot} />
      </div>
    </div>
  );
};
